var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout-footer" }, [
    _c("span", [_vm._v("善德活泉 © " + _vm._s(_vm.year) + " 供应商平台")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }